/**
 * Money — the Rial is an INTEGER everywhere (no floats for currency; kills float-drift, R18).
 * A `Rial` is a branded number so a raw number can't be passed where money is expected by mistake.
 */
/**
 * Largest integer rial that binds safely to a SQLite INTEGER column. Above this, node:sqlite THROWS when it
 * READS the value back (it can't represent >2^53 as a JS number), which 500s every subsequent read of that
 * table — one huge/pasted number bricks the whole subsystem. So every money INPUT must be rejected above it.
 */
export const MAX_RIAL = Number.MAX_SAFE_INTEGER;
/** Construct a Rial from a value, rounding to the nearest integer rial. Throws on non-finite input. */
export function rial(value) {
    if (!Number.isFinite(value))
        throw new TypeError(`Invalid Rial value: ${value}`);
    return Math.round(value);
}
export function addRial(...values) {
    return rial(values.reduce((sum, v) => sum + v, 0));
}
export function mulRial(amount, factor) {
    return rial(amount * factor);
}
/** Format for display: Latin thousands-separated digits + the Rial sign, e.g. "1,250,000 ﷼". */
export function formatRial(value) {
    if (value == null || !Number.isFinite(value))
        return '—';
    return `${Math.round(value).toLocaleString('en-US')} ﷼`;
}
/** Format a ratio (0.375) as a Persian percent string ("۳۷٫۵٪" style but Latin digits): "37.5٪". */
export function formatPercent(value, digits = 1) {
    if (value == null || !Number.isFinite(value))
        return '—';
    return `${(value * 100).toFixed(digits)}٪`;
}
//# sourceMappingURL=money.js.map